<template>
  <table class="table">
    <thead>
      <slot name="columns">
        <th :key="JSON.stringify(column)" v-for="column in columns">{{column}}</th>
      </slot>
    </thead>
    <tbody>
      <tr :key="JSON.stringify(item)" v-for="item in data">
        <slot :item="item">
          <td v-for="column in columns" :key="JSON.stringify(column)" v-if="hasValue(item, column)">
            <img
              style="width: 40px; height: 40px; border-radius: 20px"
              :src="item['profile_picture'] || require('../../../static/img/default-dp.png')"
              v-if="isImage(item, column)"
            >
            <span v-else>{{itemValue(item, column)}}</span>
          </td>
        </slot>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  props: {
    columns: Array,
    data: Array,
    title: {
      type: String,
      default: ""
    },
    subTitle: {
      type: String,
      default: ""
    }
  },
  methods: {
    hasValue(item, column) {
      return item[column.toLowerCase()] !== "undefined";
    },
    isImage(item, column) {
      return column.toLowerCase() === "avatar";
    },
    itemValue(item, column) {
      const lowerCaseColumn = column.toLowerCase();
      if (lowerCaseColumn === "phone number") {
        return item["phoneNumber"];
      } else if (lowerCaseColumn === "nic") {
        return item["nicNumber"];
      } else {
        return item[column.toLowerCase()];
      }
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Table.vue